import(/* webpackMode: "eager" */ "/home/runner/work/joyboy/joyboy/apps/web/app/[deviceTheme]/[region]/[locale]/(auth)/login/page.tsx");
